/** Подписи статуса заказа в UI (совпадают с бэкендом). */
export function orderStatusLabel(status: string): string {
  switch (status) {
    case 'open':
      return '📢 Открыто';
    case 'in_progress':
      return '⚡ В работе';
    case 'completed':
      return '✅ Выполнено (ждёт подтверждения)';
    case 'awaiting_payment':
      return '💳 Ожидает оплаты исполнителю';
    case 'finished':
      return '🎉 Завершено';
    case 'cancelled':
      return '❌ Отменено';
    default:
      return status;
  }
}
